import React from "react";
import { Typography, Button } from "Components/shared/oneui";
import { getFormattedDate, getFormattedTime } from "Utils/common";
import clsx from "clsx";

const RefreshBtn = ({ isMobile, updateFilter }) => {
  return (
    <>
      <Typography
        variant="P2"
        className={clsx({
          "twside-text-green-gray-300": true,
          "twside-mb-8": !isMobile,
        })}
      >
        As of {getFormattedDate(new Date())} {getFormattedTime(new Date())}
      </Typography>
      <div
        className={clsx({
          "twside-py-24 twside-px-16 twside-bg-seablue-10 twside-mt-4":
            isMobile,
        })}
      >
        <Button
          fullWidth={isMobile}
          onClick={() => {
            updateFilter({
              isCurrentlyDown: true,
              pageOffset: 0,
            });
          }}
          startIcon={{
            // color: "#41A18D",
            className: 'twside-text-primary-500',
            size: "s",
            type: "refresh",
          }}
          variant="SECONDARY"
        >
          Refresh
        </Button>
      </div>
    </>
  );
};

export default RefreshBtn;
